import { useState, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Alert, Stack, Button } from '@mui/material';

import Select from '../../form/Select';

import SelectEmpresa from '../../form/SelectEmpresa';

import DataListLabel from '../../form/DataListLabel';

import { opcoesUsuario, recuperarUsuario } from './usuarioPermissao';

import Checkbox from '../../form/Checkbox';

//utils

import * as UsuarioAPI from '../../../api/usuario';

import * as TabelaAPI from '../../../api/tabela';

function Form({
    token,

    dados,

    setDados,

    empresaId,

    empresaIds,

    pessoaId,

    parametro,

    handleSubmit,

    btnText,

    caminhoVoltar,

    OptionsEmpresa,

    OptionsMenus,
}) {
    const [usuarios, setUsuario] = useState([]);

    const [usuarioTexto, setUsuarioTexto] = useState('');

    const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);

    const [erroUsuario, setErroUsuario] = useState('');

    const [salvando, setSalvando] = useState(false);

    const [menuSubs, setMenuSub] = useState([]);

    const navigate = useNavigateParams();

    const location = useLocation();

    const urlParams = new URLSearchParams(location.search);

    const [disabledUsuarioCheckbox, setIsDisabledUsuario] = useState(false);

    const [disabledCheckbox, setIsDisabled] = useState(false);

    const usuariosPermitidos = ['8', '13'];

    const editando = !!urlParams.get('uuid') && urlParams.get('uuid') !== 'null';

    useEffect(() => {
        let vigente = true;

        setUsuario([]);

        setUsuarioTexto('');

        setErroUsuario('');

        if (!dados.empresaId) {
            setCarregandoUsuarios(false);

            return;
        }

        setCarregandoUsuarios(true);

        UsuarioAPI.usuario(null, dados.empresaId)

            .then((result) => {
                if (!vigente) return;

                if (!Array.isArray(result)) throw result;

                const opcoes = opcoesUsuario(result);

                setUsuario(opcoes);

                if (!editando) {
                    const lembrado = recuperarUsuario(pessoaId, dados.empresaId, opcoes);

                    setDados((prev) => ({ ...prev, pessoaId: lembrado?.id || null }));
                }
            })

            .catch((e) => {
                if (vigente) setErroUsuario(e?.response?.data?.message || 'Não foi possível carregar os usuários.');
            })

            .finally(() => {
                if (vigente) setCarregandoUsuarios(false);
            });

        return () => {
            vigente = false;
        };
    }, [dados.empresaId, pessoaId, editando, setDados]);

    useEffect(() => {
        if (!dados.pessoaId) return;
        const selecionado = usuarios.find((p) => String(p.id) === String(dados.pessoaId));
        setUsuarioTexto(selecionado?.descricao || '');
    }, [usuarios, dados.pessoaId]);

    function selecionarUsuario(e) {
        const texto = e.target.value;
        setUsuarioTexto(texto);
        const encontrados = usuarios.filter((p) => p.descricao === texto);
        const selecionado = encontrados.length === 1 ? encontrados[0] : null;
        setDados((prev) => ({ ...prev, pessoaId: selecionado?.id ?? null }));
        setErroUsuario(encontrados.length > 1 ? 'Existe mais de um usuário com essa descrição.' : '');
    }

    const consultaMenuSub = async (menuId, descricao) => {
        if (!menuId) {
            return;
        }

        try {
            const result = await TabelaAPI.menuSub(menuId, descricao);

            setMenuSub(Array.isArray(result) && result.length > 0 ? result : []);

            if (String(btnText || '').toLowerCase() === 'cadastrar') {
                setDados((prev) => ({
                    ...prev,

                    menuSubId: Array.isArray(result) && result.length > 0 ? result[0].id : null,
                }));
            }

            return result;
        } catch (error) {
            console.error(error);

            //posso colocar um setFlash..
        }
    };

    const atualizaMenuSub = async (id) => {
        const result = await TabelaAPI.tabelaById('', 'menuSub', id);

        setDados((prev) => ({
            ...prev,

            menuSub: result,
        }));
    };

    const buscaUsuarioPermitido = async (empresaId, pessoaId) => {
        if (!empresaId || !pessoaId) {
            return null;
        }

        const result = await UsuarioAPI.buscaUsuarioPermitido(empresaId, pessoaId);

        if (String(dados.menuSubId) === '3') {
            setIsDisabledUsuario(result ? false : true);
        } else {
            setIsDisabledUsuario(true);
        }
    };

    useEffect(() => {
        setIsDisabled(parseInt(dados.menuSubId) === 54 && !usuariosPermitidos.includes(String(pessoaId))); //menu de ajuda

        if (dados.menuSubId) {
            //atualiza o menuSub

            atualizaMenuSub(dados.menuSubId);

            buscaUsuarioPermitido(dados.empresaId, dados.pessoaId);
        }
    }, [dados.menuSubId, dados.pessoaId, dados.empresaId]);

    useEffect(() => {
        if (dados.menuId) {
            consultaMenuSub(dados.menuId);
        }
    }, [dados.menuId]);

    useEffect(() => {
        const menu = dados.menuSub;

        const campos = [
            'incluir',

            'editar',

            'imprimir',

            'cancelar',

            'baixar',

            'cancelarBaixa',

            'editarItem',

            'imprimirItem',

            'cancelarItem',

            'transformar',

            'custos',

            'usuario',

            'conferir',

            'reajustarPreco',
        ];

        setDados((prev) => {
            const alterar = campos.filter((campo) => menu?.[campo] === false && prev[campo] !== false);

            return alterar.length ? { ...prev, ...Object.fromEntries(alterar.map((c) => [c, false])) } : prev;
        });
    }, [dados.menuSub, setDados]);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'empresaId' && editando) {
            setErroUsuario('Para trocar a empresa, cadastre uma nova permissão.');

            return;
        }

        setDados((prev) => ({
            ...prev,

            [name]: type === 'checkbox' ? checked : value,

            ...(name === 'empresaId' ? { pessoaId: null } : {}),
        }));
    }

    async function handleOnBlur(e) {}

    async function handleOnFocus(e) {}

    const submit = async (e) => {
        e.preventDefault();

        if (salvando || carregandoUsuarios) return;

        const selecionado = usuarios.find((p) => String(p.id) === String(dados.pessoaId) && p.descricao === usuarioTexto);
        if (!selecionado) {
            setErroUsuario('Selecione um usuário válido na lista.');
            return;
        }

        if (!dados.empresaId || !dados.menuId || !dados.menuSubId) {
            setErroUsuario('Selecione empresa, menu e submenu.');

            return;
        }

        let payload = { ...dados, pessoaId: selecionado.id };

        if (Number(dados.menuSubId) === 54 && usuariosPermitidos.includes(String(pessoaId))) {
            payload = {
                ...payload,

                baixar: false,

                cancelar: false,

                cancelarBaixa: false,

                custos: false,

                editar: false,

                incluir: false,

                usuario: false,
            };
        }

        setErroUsuario('');

        setSalvando(true);

        try {
            await handleSubmit(payload);
        } finally {
            setSalvando(false);
        }
    };

    return (
        <form onSubmit={submit}>
            <h1>Gestão de Permissões</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId}
                    notOptNull={true}
                    required
                />

                <DataListLabel
                    text="Usuário"
                    name="usuarioPermissao"
                    filteredOptions={usuarios}
                    displayField="descricao"
                    handleOnChange={selecionarUsuario}
                    value={usuarioTexto}
                    inputWidth="650px"
                    placeholder={carregandoUsuarios ? 'Carregando usuários…' : 'Busque pelo nome, usuário ou CPF'}
                    readonly={carregandoUsuarios || salvando || editando}
                    required
                />

                {erroUsuario && <Alert severity="error">{erroUsuario}</Alert>}

                <Select
                    text="Selecione o Menu"
                    name="menuId"
                    options={OptionsMenus}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.menuId || ''}
                    isEnum={false}
                />

                <Select
                    text="Selecione o SubMenu"
                    name="menuSubId"
                    options={menuSubs}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.menuSubId || ''}
                    isEnum={false}
                />
            </div>
            <h4>Padrão</h4>
            <div>
                <Checkbox
                    title="Quando marcado a permissão esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />

                <Checkbox
                    title="Quando marcado permitirá VISUALIZAR"
                    text="Visualizar"
                    name="visualizar"
                    handleOnChange={handleChange}
                    value={dados.visualizar}
                    checked={!!dados.visualizar}
                />

                <Checkbox
                    title="Quando marcado permitirá INCLUIR"
                    text="Incluir"
                    name="incluir"
                    handleOnChange={handleChange}
                    value={dados.incluir}
                    checked={dados.incluir}
                    disabled={!dados.menuSub?.incluir || disabledCheckbox}
                />

                <Checkbox
                    title="Quando marcado permitirá EDITAR"
                    text="Editar"
                    name="editar"
                    handleOnChange={handleChange}
                    value={dados.editar}
                    checked={dados.editar}
                    disabled={!dados.menuSub?.editar || disabledCheckbox}
                />

                <Checkbox
                    title="Quando marcado permitirá IMPRIMIR"
                    text="Imprimir"
                    name="imprimir"
                    handleOnChange={handleChange}
                    value={dados.imprimir}
                    checked={dados.imprimir}
                    disabled={!dados.menuSub?.imprimir}
                />

                <Checkbox
                    title="Quando marcado permitirá CANCELAR"
                    text="Cancelar"
                    name="cancelar"
                    handleOnChange={handleChange}
                    value={dados.cancelar}
                    checked={dados.cancelar}
                    disabled={!dados.menuSub?.cancelar || disabledCheckbox}
                />
            </div>
            <h4>Mesclagem de produtos</h4>
            <Checkbox
                text="Mesclar produtos"
                title="Autoriza mesclagem auditada. Concessão restrita a administrador com acesso à empresa."
                name="mesclarProdutos"
                checked={dados.mesclarProdutos === true || dados.mesclarProdutos === 1 || dados.mesclarProdutos === '1'}
                value={dados.mesclarProdutos || false}
                handleOnChange={handleChange}
                disabled={disabledCheckbox || String(dados.menuSub?.url || '').split('?')[0].replace(/\/+$/, '').toLowerCase() !== '/produtos' || !!dados.menuSub?.operacaoId || !dados.visualizar || !dados.editar}
            />
            <h4>Administrativo</h4>{' '}
            <div>
                <Checkbox
                    title="Permite reajustar preços dos produtos"
                    text="Reajustar"
                    name="reajustarPreco"
                    handleOnChange={handleChange}
                    value={dados.reajustarPreco}
                    checked={dados.reajustarPreco}
                    disabled={!dados.menuSub?.reajustarPreco || disabledCheckbox}
                />

                <Checkbox
                    title="Permite cadastrar ou editar usuário"
                    text="Usuário"
                    name="usuario"
                    handleOnChange={handleChange}
                    value={dados.usuario}
                    checked={dados.usuario}
                    disabled={!dados.menuSub?.usuario || disabledUsuarioCheckbox}
                />
            </div>
            <h4>Financeiro</h4>{' '}
            <div>
                <Checkbox
                    title="Quando marcado permitirá BAIXAR, funciona apenas no modulo FINANCEIRO"
                    text="Baixar"
                    name="baixar"
                    handleOnChange={handleChange}
                    value={dados.baixar}
                    checked={dados.baixar}
                    disabled={!dados.menuSub?.baixar}
                />

                <Checkbox
                    title="Quando marcado permitirá CANCELAR BAIXAR, funciona apenas no modulo FINANCEIRO"
                    text="Cancelar Baixa"
                    name="cancelarBaixa"
                    handleOnChange={handleChange}
                    value={dados.cancelarBaixa}
                    checked={dados.cancelarBaixa}
                    disabled={!dados.menuSub?.cancelarBaixa}
                />
            </div>
            <h4>Movimento</h4>
            <div>
                <Checkbox
                    title="Quando marcado permitirá EDITAR ITEM nos movimentos"
                    text="Editar Item"
                    name="editarItem"
                    handleOnChange={handleChange}
                    value={dados.editarItem}
                    checked={dados.editarItem}
                    disabled={!dados.menuSub?.editarItem || disabledCheckbox}
                />

                <Checkbox
                    title="Quando marcado permitirá IMPRIMIR ITEM nos movimentos"
                    text="Imprimir Item"
                    name="imprimirItem"
                    handleOnChange={handleChange}
                    value={dados.imprimirItem}
                    checked={dados.imprimirItem}
                    disabled={!dados.menuSub?.imprimirItem || disabledCheckbox}
                />

                <Checkbox
                    title="Quando marcado permitirá CANCELAR ITEM nos movimentos"
                    text="Cancelar Item"
                    name="cancelarItem"
                    handleOnChange={handleChange}
                    value={dados.cancelarItem}
                    checked={dados.cancelarItem}
                    disabled={!dados.menuSub?.cancelarItem || disabledCheckbox}
                />

                <Checkbox
                    title="permite ao usuário fazer conferências exemplo: caixas, etc"
                    text="Conferir"
                    name="conferir"
                    handleOnChange={handleChange}
                    value={dados.conferir}
                    checked={dados.conferir}
                    disabled={!dados.menuSub?.conferir || disabledCheckbox}
                />

                <Checkbox
                    title="Quando marcado permitirá TRANSFORMAR"
                    text="Transformar"
                    name="transformar"
                    handleOnChange={handleChange}
                    value={dados.transformar}
                    checked={dados.transformar}
                    disabled={!dados.menuSub?.transformar}
                />

                <Checkbox
                    title="Quando marcado permitirá visualizar custos"
                    text="Custos"
                    name="custos"
                    handleOnChange={handleChange}
                    value={dados.custos}
                    checked={dados.custos}
                    disabled={!dados.menuSub?.custos}
                />
            </div>
            <h4>Relatórios</h4>
            <div>
                <Checkbox
                    title="Permite visualizar relatórios analíticos"
                    text="Analíticos"
                    name="impAnalitico"
                    handleOnChange={handleChange}
                    value={dados.impAnalitico}
                    checked={dados.impAnalitico}
                />

                <Checkbox
                    title="Permite visualizar relatórios gerenciais"
                    text="Gerencial"
                    name="impGerencia"
                    handleOnChange={handleChange}
                    value={dados.impGerencia}
                    checked={dados.impGerencia}
                />

                <Checkbox
                    title="Permite visualizar relatórios sintéticos"
                    text="Sintéticos"
                    name="impSintetico"
                    handleOnChange={handleChange}
                    value={dados.impSintetico}
                    checked={dados.impSintetico}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() =>
                            navigate(caminhoVoltar, {
                                state: {
                                    ul: urlParams.get('ul'),

                                    li: urlParams.get('li'),

                                    tipo: urlParams.get('tipo'),
                                },
                            })
                        }
                    >
                        Voltar
                    </Button>

                    <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        disabled={salvando || carregandoUsuarios || !dados.pessoaId}
                    >
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}

export default Form;
